// src/BarcodeScannerModal.js - CORRETTO

import React, { useEffect, useRef } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';

export function BarcodeScannerModal({ onScan, onClose }) {
    const videoRef = useRef(null);
    const codeReader = new BrowserMultiFormatReader();

    useEffect(() => {
        // Avvia la fotocamera quando il componente appare
        codeReader.decodeFromVideoDevice(undefined, videoRef.current, (result, err) => {
            if (result) {
                // Trovato un codice! Ferma la scansione e invia il risultato
                codeReader.reset();
                onScan(result.getText());
            }
            // Non gestiamo 'err' perché viene chiamato continuamente quando non trova un codice
        }).catch(err => {
            console.error("Errore avvio fotocamera:", err);
            // Potrebbe essere un problema di permessi o nessuna fotocamera trovata
        });

        // Funzione di pulizia: spegne la fotocamera quando il modale si chiude
        return () => {
            codeReader.reset();
        };
    }, []);

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>Inquadra un codice a barre</h3>
                <div style={{ width: '100%', maxWidth: '400px', margin: '10px auto', position: 'relative', overflow: 'hidden', borderRadius: '8px' }}>
                    {/* Il video della fotocamera verrà mostrato qui */}
                    <video ref={videoRef} style={{ width: '100%', height: '100%' }} />
                    <div className="scanner-laser"></div>
                </div>
                <p>La scansione si fermerà automaticamente dopo aver trovato un codice. **Scansiona il codice del tuo centro.**</p>
                <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
            </div>
        </div>
    );
}